import Vue from 'vue';

import { Component } from 'vue-property-decorator';

@Component({
  name: 'bpc-enrollment-tabs',
  components: {},
})
export default class EnrollmentTabs extends Vue {}
